export default {
      id: "ic_menue-usage",
      viewBox: "0 0 92 60.99",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#ic_menue-usage",
      toString: function () {
        return this.url;
      }
    }